<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { getHealth } from '../services/api'

const status = ref<string>('loading')
const uptime = ref<number | null>(null)
const error = ref<string | null>(null)

async function checkHealth() {
  status.value = 'loading'
  error.value = null
  try {
    const data = await getHealth()
    status.value = data.status
    uptime.value = data.uptime
  } catch (e) {
    status.value = 'error'
    error.value = 'Backend unreachable'
  }
}

onMounted(() => {
  checkHealth()
})
</script>

<template>
  <div class="text-sm p-4 border dark:border-gray-700 rounded bg-gray-50 dark:bg-gray-800 flex items-center gap-4">
    <div class="font-bold text-gray-700 dark:text-gray-200">System Status:</div>
    <div v-if="status === 'loading'" class="text-gray-500">Checking...</div>
    <div v-else-if="status === 'ok'" class="text-green-600 flex items-center gap-2">
      <span class="w-2 h-2 rounded-full bg-green-500"></span>
      Operational (Uptime: {{ uptime?.toFixed(0) }}s)
    </div>
    <div v-else class="text-red-600 font-medium">
      {{ error }}
      <button @click="checkHealth" class="ml-2 text-blue-600 underline text-xs">Retry</button>
    </div>
  </div>
</template>
